import Vue from 'vue'
import Axios from "axios";
import i18n from '../i18n.js';
import vuetify from '../plugins/vuetify.plugin.js';
import "core-js/stable"

import HelperPlugin from './helper.plugin'
import ValidationPlugin from '../plugins/validation.plugin'
import App from './JobsApp.vue'
import router from './router'
import store from './store'
import UiEventBus from '../UiEventBus'

import LoadingIndicator from '../components/LoadingIndicator.vue';

import VueCustomElement from 'vue-custom-element';
import 'document-register-element/build/document-register-element';

Vue.use(VueCustomElement);

Vue.use(HelperPlugin);
Vue.use(ValidationPlugin);

Vue.component('hb-loading-indicator', LoadingIndicator);

const hasCustomBaseUrl = process.env.VUE_APP_API_BASEURL.indexOf('undefined') !== -1 ? false : true;
if (hasCustomBaseUrl) {
  Axios.defaults.baseURL = process.env.VUE_APP_API_BASEURL
}
Axios.defaults.withCredentials = true;
Axios.defaults.headers.common['Pragma'] = 'no-cache';
Axios.defaults.headers.common['Cache-Control'] = 'no-cache, no-store';
Axios.defaults.headers.common['Content-Type'] = 'application/json';
Axios.defaults.headers.common['Accept'] = 'application/json';
Vue.config.productionTip = false;

Axios.interceptors.request.use( (config) => {
  UiEventBus.$emit('addProgress');
  return Promise.resolve(config)
},(error) => {
  UiEventBus.$emit('removeProgress');
  return Promise.reject(error)
});

if (localStorage.getItem("uid") != null) {
  store.commit('setUid', localStorage.getItem("uid"));
}

vuetify.framework.theme.changeTheme('hrsata');

App.vuetify = vuetify;
App.router = router;
App.store = store;
App.i18n = i18n;

// Add a response interceptor
Axios.interceptors.response.use((response) => {
  UiEventBus.$emit('removeProgress');
  return response
}, (error) => {
  UiEventBus.$emit('removeProgress');
  return Promise.reject(error)
});

Vue.customElement('hrsata-jobs', App);
